export const ListQueryKey = 'projectTransfers';
export const DetailQueryKey = 'projectTransfer';
export const Urls = {
  selectUrl: '/tranfer/list',
  updateUrl: '/tranfer/update',
  deleteUrl: '/tranfer/delete',
  createUrl: '/tranfer/create',
  detailUrl: '/tranfer/info'
};